import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { updateGoogleCalendarTimesheetAutoSync, updateGoogleCalendarTaskAutoSync, updateGoogleCalendarTimesheetManualSync, updateGoogleCalendarTaskManualSync,updateOutlookCalendarTaskAutoSync,updateOutlookCalendarTaskManualSync,updateOutlookCalendarTimesheetAutoSync,updateOutlookCalendarTimesheetManualSync } from '../../../common/GlobalSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import Loader from '../../../common/Loader';
import Select, { components } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { validateSystemIntegration, dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import clsx from 'clsx';

const initialIntegration = {   
    GoogleCalendarIsConnected: false,
    GoogleCalendarClientId: '',
    GoogleCalendarSecret: '',
    GoogleCalendarCallBack: '',
    GoogleCalendarState: '',
    GoogleCalendarSystemIntegrationId: '',
    CommaSeparatedCalendarIds: '',
    GoogleCalendarItems: [],
    OutlookCalendarIsConnected: false,
    OutlookCalendarClientId: '',
    OutlookCalendarSecret: '',
    OutlookCalendarCallBack: '',
    OutlookCalendarState: '',
    OutlookCalendarSystemIntegrationId: '',
    OutlookCalendarItems: [],
    IsTask: false,
    IsTaskManual: false,
    IsTimeSheet: false,
    IsTimeSheetManual: false,
    IsOutlookTask: false,
    IsOutlookTaskManual: false,
    IsOutlookTimeSheet: false,
    IsOutlookTimeSheetManual: false
}

export const EmployeeIntegrations = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const ConnectedButtonRef = useRef<any>(null);
    const OutlookConnectedButtonRef = useRef<any>(null);
    const [googlecalendarItemsArray, SetGooglecalendarItemsArray] = useState<any | ''>([]);
    const navigate = useNavigate();
    const googlecalendar_clientId = '746449382374-odim9bg2213d2vtg6uqmsk5atvu8b79g.apps.googleusercontent.com';
    const googlecalendar_callback_uri = 'https://localdebug.livetecs.com/Handler/Integration/GoogleCalendar.ashx';
    const googlecalendar_scope = 'https://www.googleapis.com/auth/calendar';
    const outlookcalendar_scope = 'openid profile email offline_access Calendars.ReadWrite';
    const [isIntegerationConnected, setIsIntegerationConnected] = useState(initialIntegration);
    const [isLoading, setIsLoading] = useState(true);
    const { sessionAccountId, sessionAccountEmployeeId,AccountIdsForGoogleCalendar,AccountIdsForOutlookCalendar } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    useEffect(() => {
        getIntegerationDataAsync();
    }, []);

    useEffect(() => {
        if (isIntegerationConnected.GoogleCalendarIsConnected) {
            if (ConnectedButtonRef.current) {
                ConnectedButtonRef.current.click();
            }
        }
    }, [isIntegerationConnected.GoogleCalendarIsConnected]);

    useEffect(() => {
        if (isIntegerationConnected.OutlookCalendarIsConnected) {
            if (OutlookConnectedButtonRef.current) {
                OutlookConnectedButtonRef.current.click();
            }
        }
    }, [isIntegerationConnected.OutlookCalendarIsConnected]);

    const getIntegerationDataAsync = async () => {
        try {
            const response: any = await fetchAPI(`api/v2/Integrations/QB/GetAccountIntegerations/${sessionAccountId}/${sessionAccountEmployeeId}`, "GET", "", true);
            const json = await response.json();
            let isGoogleCalendarConnected = json["GoogleCalendarIntegration"] ? (json["GoogleCalendarIntegration"].AccessToken != '' ? true : false) : false;    
            let tempCommaSeparatedCalendarIds = json["GoogleCalendarSettings"].find((item: any) => item.Key === "CommaSeparatedCalendarIds")?.Value;           
            let tempGoogleCalendarItems = ((json["GoogleCalendarList"] && json["GoogleCalendarList"].length > 0) ?
                json["GoogleCalendarList"].map((item: any) => {
                    if (tempCommaSeparatedCalendarIds.includes(item.value)) {
                        return { ...item, isSelected: 1 };
                    }
                    return item;
                }) : []);
            let tempCommaSeparatedOutlookCalendarIds = json["OutlookCalendarSettings"].find((item: any) => item.Key === "CommaSeparatedCalendarIds")?.Value;
            let isOutlookCalendarConnected = json["OutlookCalendarIntegration"] ? (json["OutlookCalendarIntegration"].AccessToken != '' ? true : false) : false;
            let tempOutlookCalendarItems = ((json["OutlookCalendarList"] && json["OutlookCalendarList"].length > 0) ?
                json["OutlookCalendarList"].map((item: any) => {
                    if (tempCommaSeparatedOutlookCalendarIds.includes(item.value)) {
                        return { ...item, isSelected: 1 };
                    }
                    return item;
                }) : []);
            setIsIntegerationConnected({
                ...isIntegerationConnected,              
                GoogleCalendarIsConnected: isGoogleCalendarConnected ? validateSystemIntegration(json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarSystemIntegrationId")?.Value.toUpperCase()) === 'GoogleCalendar' ? true : false : false,
                GoogleCalendarClientId: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarClientId")?.Value,
                GoogleCalendarCallBack: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarCallBack")?.Value,
                GoogleCalendarState: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarState")?.Value,
                CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds,
                GoogleCalendarItems: tempGoogleCalendarItems,
                OutlookCalendarIsConnected: isOutlookCalendarConnected ? validateSystemIntegration(json["OutlookCalendarSettings"].find((item: any) => item.Key === "OutlookCalendarSystemIntegrationId")?.Value.toUpperCase()) === 'OutlookCalendar' ? true : false : false,
                OutlookCalendarClientId: json["OutlookCalendarSettings"].find((item: any) => item.Key === "OutlookCalendarClientId")?.Value,
                OutlookCalendarCallBack: json["OutlookCalendarSettings"].find((item: any) => item.Key === "OutlookCalendarCallBack")?.Value,
                OutlookCalendarState: json["OutlookCalendarSettings"].find((item: any) => item.Key === "OutlookCalendarState")?.Value,
                OutlookCalendarItems: tempOutlookCalendarItems,
                IsTask: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value,
                IsTaskManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value,
                IsTimeSheet: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheet")?.Value,
                IsTimeSheetManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value,
                IsOutlookTask: json["OutlookCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value,
                IsOutlookTaskManual: json["OutlookCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value,
                IsOutlookTimeSheet: json["OutlookCalendarSettings"].find((item: any) => item.Key === "IsTimeSheet")?.Value,
                IsOutlookTimeSheetManual: json["OutlookCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value,
            });
            dispatch(updateGoogleCalendarTaskAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value));
            dispatch(updateGoogleCalendarTimesheetAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value));
            dispatch(updateGoogleCalendarTaskManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTIsTimeSheetask")?.Value));
            dispatch(updateGoogleCalendarTimesheetManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value));
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const updateCalendarIds = async (systemIntegrationId: string, commaSeparatedCalendarIds: string) => {
        const response = await fetchAPI(`api/v2/Integrations/updateCalendarIds`, 'PUT', {
            systemIntegrationId,
            commaSeparatedCalendarIds
        }, true);
    };

    const updateIntegrationSyncAsync = async (checked: boolean, name: string, systemIntegrationId: string) => {
        const response = await fetchAPI(`api/V2/Integrations/updateIntegration/${checked}/${name}/${systemIntegrationId}`, "PUT", "", true, "");
    };

    const handlePropertyChange = (selectedOption: any[]) => {
        const values = selectedOption.map((option: any) => option.value.trim());      
        const newState = [...isIntegerationConnected.GoogleCalendarItems];
        const selectedValuesSet = new Set(values);
        newState.forEach((item: any) => {
            if (selectedValuesSet.has(item.value.trim())) {
                item.isSelected = 1;
            } else {
                item.isSelected = 0;
            }
        });
        let tempCommaSeparatedCalendarIds = newState
            .filter((item: any) => item.isSelected == 1)
            .map((item: any) => item.value)
            .join(',')
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            GoogleCalendarItems: newState,
            CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds
        });
        updateCalendarIds("3B00775F-9B50-4A7D-926F-1192E2E3033E", tempCommaSeparatedCalendarIds);
    }

    const handleOutlookPropertyChange = (selectedOption: any[]) => {
        const values = selectedOption.map((option: any) => option.value.trim());
        const newState = [...isIntegerationConnected.OutlookCalendarItems];
        const selectedValuesSet = new Set(values);
        newState.forEach((item: any) => {
            if (selectedValuesSet.has(item.value.trim())) {
                item.isSelected = 1;
            } else {
                item.isSelected = 0;
            }
        });
        
        let tempCommaSeparatedCalendarIds = newState
            .filter((item: any) => item.isSelected == 1)
            .map((item: any) => item.value)
            .join(',')
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            OutlookCalendarItems: newState,
            CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds
        });
        
        updateCalendarIds("6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828", tempCommaSeparatedCalendarIds);
        
    }

    const onHandleTaskAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTask: checked
        });
        dispatch(updateGoogleCalendarTaskAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTask", "3B00775F-9B50-4A7D-926F-1192E2E3033E");
    }

    const onHandleOutlookTaskAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsOutlookTask: checked
        });
        dispatch(updateOutlookCalendarTaskAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTask" , "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
    }



    const onHandleTaskManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTaskManual: checked
        });
        dispatch(updateGoogleCalendarTaskManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTaskManual", "3B00775F-9B50-4A7D-926F-1192E2E3033E");
    }

    const onHandleOutlookTaskManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsOutlookTaskManual: checked
        });
        dispatch(updateOutlookCalendarTaskManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTaskManual", "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
    }

    const onHandleTimesheetAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheet: checked
        });
        dispatch(updateGoogleCalendarTimesheetAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheet", "3B00775F-9B50-4A7D-926F-1192E2E3033E"); 
    }

    const onHandleOutlookTimesheetAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsOutlookTimeSheet: checked
        });
        dispatch(updateOutlookCalendarTimesheetAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheet" , "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
    }

    const onHandleTimesheetManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheetManual: checked
        });
        dispatch(updateGoogleCalendarTimesheetManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheetManual" , "3B00775F-9B50-4A7D-926F-1192E2E3033E");
    }

    const onHandleOutlookTimesheetManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsOutlookTimeSheetManual: checked
        });
        dispatch(updateOutlookCalendarTimesheetManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheetManual", "6E0E6A9C-7A37-4BDA-8D6A-D7D61F00B828");
    }
 

    return (
        <>
            {isLoading && <Loader />}
            <div className="card card-custom" >
                <div className="card-header" style={{ paddingLeft: '0px' }}>
                    <h3 className="card-title fw-bold headerTitle pl-0">{t('Employee Integrations')}</h3>
                    <div className="card-toolbar">
                    </div>
                </div>
                { (AccountIdsForGoogleCalendar || AccountIdsForOutlookCalendar) &&
                <div className='row' style={{ padding: '20px 30px' }}>
                    {AccountIdsForGoogleCalendar &&
                        <div className="col-md-6">
                            <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(255 222 126 / 20%)' }}>
                                <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                    <h3 className="card-title Gc"> {t('Google Calendar')}</h3>
                                    <div className="card-toolbar">
                                        <img src={toAbsoluteUrl('/media/logos/integrations/g-calendar.png')} />
                                    </div>
                                </div>
                                <div className="card-body" style={{ height: '120px', overflow: 'scroll' }}>
                                    {isIntegerationConnected.GoogleCalendarIsConnected &&
                                        <>
                                            <div style={{ float: 'right' }}>
                                                <div className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-trigger="{default: 'click'}"
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <span
                                                        className={`btn btn-icon btn-active-light-dark '}   btn-sm ms-0 fs-7`}
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content="Integration Settings"
                                                        data-tooltip-place="bottom"
                                                    >
                                                        <i className="bi bi-gear fs-3 Gc" ></i>
                                                    </span>
                                                </div>
                                                <div className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary py-4 fs-6 w-350px`}
                                                    data-kt-menu='true'
                                                >
                                                    <div className={"row tsDescriptionWidget "}>
                                                        <div className={"col-md-12 col-sm-12 col-xs-12"}>
                                                            <h4 className="card-title fw-bold titleHeading">{t(`Integration Settings`)}</h4>
                                                            <div className="separator my-2"></div>
                                                            <div className="mb-2 col-md-12 col-xs-12">
                                                                <div className="row col-md-12 col-xs-12 mb-1">
                                                                    <div className="col-md-9">
                                                                        <label className="fs-7 fs-7 fw-normal">Calendar List</label>
                                                                    </div>
                                                                </div>
                                                                <Select
                                                                    value={isIntegerationConnected.GoogleCalendarItems.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}
                                                                    closeMenuOnSelect={false}
                                                                    options={isIntegerationConnected.GoogleCalendarItems}
                                                                    isMulti
                                                                    onChange={(selectedOptions: any) =>
                                                                        handlePropertyChange(selectedOptions)
                                                                    }
                                                                    components={{ MultiValue }}
                                                                    hideSelectedOptions={false}
                                                                    styles={dropDownSelectionStyles}
                                                                    maxMenuHeight={maxMenuHeight}
                                                                />
                                                            </div>
                                                            <span className='fw-bold'>{t(`Timesheet`)}</span>
                                                            <div className="separator my-2"></div>
                                                            <div className="row mb-2 col-md-12">
                                                                <div className='col-md-6'>
                                                                    <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                    <div className={"form-group"}>
                                                                        <div className="form-check form-switch form-check-custom">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                                                //checked={isGoogleCalendarTimesheetAutoSync}
                                                                                checked={isIntegerationConnected.IsTimeSheet}
                                                                                onChange={(e) => { onHandleTimesheetAutoSync(e) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                    <div className={"form-group"}>
                                                                        <div className="form-check form-switch form-check-custom">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                                                // checked={isGoogleCalendarTimesheetManualSync}
                                                                                checked={isIntegerationConnected.IsTimeSheetManual}
                                                                                onChange={(e) => { onHandleTimesheetManualSync(e) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className='fw-bold'>{t(`Task`)}</span>
                                                            <div className="separator my-2"></div>
                                                            <div className="row mb-2 col-md-12">
                                                                <div className='col-md-6'>
                                                                    <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                    <div className={"form-group"}>
                                                                        <div className="form-check form-switch form-check-custom">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                                                //checked={isGoogleCalendarTaskAutoSync}
                                                                                checked={isIntegerationConnected.IsTask}
                                                                                onChange={(e) => { onHandleTaskAutoSync(e) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-md-6'>
                                                                    <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                    <div className={"form-group"}>
                                                                        <div className="form-check form-switch form-check-custom">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input custom-padding-right h-15px w-30px"
                                                                                // checked={isGoogleCalendarTaskManualSync}
                                                                                checked={isIntegerationConnected.IsTaskManual}
                                                                                onChange={(e) => { onHandleTaskManualSync(e) }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <p className="connected Gc">
                                                <i className="fa fa-check Gc" style={{ color: '#0f6f85', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")}
                                            </p>
                                        </>
                                    }
                                    <p className="desc"> {t('Google Calendar lets you organize your Company schedule and share events with co-workers and Employees.')}</p>
                                </div>
                                <div className="card-footer">
                                    {!isIntegerationConnected.GoogleCalendarIsConnected ?
                                        <Link to={`https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`}
                                            className='btn btn-sm'
                                            style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                        >
                                            <span style={{ verticalAlign: '0.2em' }}>  {t('Connect to Google Calendar')}</span>
                                        </Link>
                                        :
                                        <Link to={``}
                                            className='btn btn-sm'
                                            style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                            ref={ConnectedButtonRef}
                                        >
                                            <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                        </Link>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {AccountIdsForOutlookCalendar &&
                    <div className="col-md-6">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(208 239 246 / 55%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Gc"> {t('Outlook Calendar')}</h3>
                                <div className="card-toolbar">
                                    <img src={toAbsoluteUrl('/media/logos/integrations/outlookCalendar.png')} />
                                </div>
                            </div>
                            <div className="card-body" style={{ height: '120px', overflow: 'scroll' }}>
                                {isIntegerationConnected.OutlookCalendarIsConnected &&
                                    <>
                                        <div style={{ float: 'right' }}>
                                            <div className={clsx('cursor-pointer symbol')}
                                                data-kt-menu-trigger="{default: 'click'}"
                                                data-kt-menu-attach='parent'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                <span
                                                    className={`btn btn-icon btn-active-light-dark '}   btn-sm ms-0 fs-7`}
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content="Integration Settings"
                                                    data-tooltip-place="bottom"
                                                >
                                                    <i className="bi bi-gear fs-3 Gc" ></i>
                                                </span>
                                            </div>
                                            <div className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary py-4 fs-6 w-350px`}
                                                data-kt-menu='true'
                                            >
                                                <div className={"row tsDescriptionWidget "}>
                                                    <div className={"col-md-12 col-sm-12 col-xs-12"}>
                                                        <h4 className="card-title fw-bold titleHeading">{t(`Integration Settings`)}</h4>
                                                        <div className="separator my-2"></div>
                                                        <div className="mb-2 col-md-12 col-xs-12">
                                                            <div className="row col-md-12 col-xs-12 mb-1">
                                                                <div className="col-md-9">
                                                                    <label className="fs-7 fs-7 fw-normal">Calendar List</label>
                                                                </div>
                                                            </div>
                                                            <Select
                                                                value={isIntegerationConnected.OutlookCalendarItems.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}
                                                                closeMenuOnSelect={false}
                                                                options={isIntegerationConnected.OutlookCalendarItems}
                                                                isMulti
                                                                onChange={(selectedOptions: any) =>
                                                                    handleOutlookPropertyChange(selectedOptions)
                                                                }
                                                                components={{ MultiValue }}
                                                                hideSelectedOptions={false}
                                                                styles={dropDownSelectionStyles}
                                                                maxMenuHeight={maxMenuHeight}
                                                            />
                                                        </div>
                                                        <span className='fw-bold'>{t(`Timesheet`)}</span>
                                                        <div className="separator my-2"></div>
                                                        <div className="row mb-2 col-md-12">
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsOutlookTimeSheet}
                                                                            onChange={(e) => { onHandleOutlookTimesheetAutoSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsOutlookTimeSheetManual}
                                                                            onChange={(e) => { onHandleOutlookTimesheetManualSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className='fw-bold'>{t(`Task`)}</span>
                                                        <div className="separator my-2"></div>
                                                        <div className="row mb-2 col-md-12">
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsOutlookTask}
                                                                            onChange={(e) => { onHandleOutlookTaskAutoSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsOutlookTaskManual}
                                                                            onChange={(e) => { onHandleOutlookTaskManualSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <p className="connected Gc">
                                            <i className="fa fa-check Gc" style={{ color: '#0f6f85', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")}
                                        </p>
                                    </>
                                }
                                <p className="desc"> {t('Outlook Calendar allows professionals to efficiently organize their company’s schedule, manage appointments, and seamlessly share events with co-workers, employees, and team members for better collaboration.')}</p>
                            </div>
                            <div className="card-footer">
                                {!isIntegerationConnected.OutlookCalendarIsConnected ? (
                                    <Link
                                        to={`https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${isIntegerationConnected.OutlookCalendarClientId}&redirect_uri=${isIntegerationConnected.OutlookCalendarCallBack}&response_type=code&scope=${outlookcalendar_scope}&state=${isIntegerationConnected.OutlookCalendarState}&response_mode=query`}
                                        className="btn btn-sm"
                                        style={{ background: "#00b7e2", color: "white", opacity: "0.7" }}
                                    >
                                        <span style={{ verticalAlign: "0.2em" }}>{t("Connect to Outlook Calendar")}</span>
                                    </Link>
                                ) : (
                                    <Link
                                        to={``}
                                        className="btn btn-sm"
                                        style={{ background: "#00b7e2", color: "white", opacity: "0.7" }}
                                        ref={OutlookConnectedButtonRef}
                                    >
                                        <span style={{ verticalAlign: "0.2em" }}>{t("Connected")}</span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                    }
                </div>}
                { (!AccountIdsForGoogleCalendar && !AccountIdsForOutlookCalendar) &&
                <div className='row' style={{ padding: '20px 30px' }}>
                   
                   <div className=''>
                                       <p className='noDataFound'>
                                           {/* {t('No Record Found')} */}
                                           {getValueFromResource('No Record Found',dispatch, t)}
                                           </p>
                                   </div>
                   
                    
                </div> }
            </div>
        </>
    )
}

const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
};
const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};